/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

document.addEventListener("DOMContentLoaded", function() {
    setTimeout(function() {
        let inStockFilter = document.querySelector('input[name="filter.v.availability"][value="1"]');
        
        if (inStockFilter) {
            console.log("✅ Found In Stock checkbox:", inStockFilter);
            
            if (!inStockFilter.checked) {
                inStockFilter.checked = true;
                inStockFilter.dispatchEvent(new Event('change', { bubbles: true }));
                console.log("✅ Checked 'In Stock' filter and applied change event.");
            } else {
                console.log("ℹ️ 'In Stock' filter was already checked.");
            }
        } else {
            console.log("❌ In Stock filter checkbox not found.");
        }
    }, 500); // load time testing
});





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
